import React from "react";
import { AppBar } from "react-admin";
import MyUserMenu from "./menu-user.js";

const MyAppBar = props => <AppBar {...props} userMenu={<MyUserMenu />} />;

export default MyAppBar;
